'use client';

/**
 * Help Plan - Custom Layout
 * All components are specific to this plan only, kept in this folder.
 */

import { PlanIntroSection } from '../common/plan-intro-section';
import { FeaturesSection } from '../common/features-section';
import { WhatIsSoftwareSection } from '../common/what-is-software-section';
import { AdvantagesSection } from '../common/advantages-section';
import { WhatIsPlanSection } from './WhatIsPlanSection';
import { HowItWorksSection } from './HowItWorksSection';
import { CommissionsSection } from './CommissionsSection';

interface MLMPlan {
    slug: string;
    name: string;
    description: string;
    content: string;
    image?: string;
    features?: string[];
}

interface PlanDetailContentProps {
    plan: MLMPlan;
}

export default function PlanDetailContent({ plan }: PlanDetailContentProps) {
    return (
        <div className="min-h-screen bg-white dark:bg-gray-950">
            <PlanIntroSection
                plan={plan}
                translationNamespace="planDetails.helpPlan.hero"
                imageSrc="/images/mlm-plans/help_animate.gif"
                descriptionKeys={['description1', 'description2']}
            />
            <WhatIsPlanSection plan={plan} />
            <WhatIsSoftwareSection
                plan={plan}
                translationNamespace="planDetails.helpPlan.whatIsSoftware"
                imageSrc="/images/mlm-plans/mlm-software-demo.webp"
            />
            <HowItWorksSection plan={plan} />
            <FeaturesSection plan={plan} translationNamespace="planDetails.helpPlan.features" />
            <CommissionsSection plan={plan} />
            <AdvantagesSection
                plan={plan}
                translationNamespace="planDetails.helpPlan.advantages"
                advantageKeys={['item1', 'item2', 'item3']}
                gridCols="3"
                hasAdditionalDescription={true}
                sectionVariant="gradient"
            />
        </div>
    );
}

